<template>
<div>

    <div class="mcc-page-header">
        <div class="mu-d-flex">

            <section class="mu-d-flex ">
                <h1 class="mu-mb-00">Processes</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">

                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
        </div>
    </div>

    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Design</li>
                <li>Processes</li>
                <li class="lastBredCrumpLi">

                </li>
            </ol>
        </nav>
        <Drawer ref="customFilter" @reset-filter="resetForm" @apply-filter="submitDialog" title="Process Filters">
            <div class="mcc-row">
                <form id="formIdd">
                <div>
                    <div class="mfc-input-wrapper mfc-input-wrapper-sm mu-mb-03 mfc-form-input-container">
                        <label for="name">Name</label>
                        <input type="text" name="form-name" maxlength="50" id="name" :pattern="nameRegex" :value="processNameRef" @change="processNameRef = $event.target.value">

                    </div>
                    <div class="mfc-slim-select-wrapper mu-mb-03">
                        <label for="selectPage" class="mu-mb-00">Applications</label>
                        <select @change="selectedApplicationRef = $event.target.value" ref="dropdownRef" name="application-select" id="application-selectId" block label="Applications">
                            <option data-placeholder="true"></option>
                            <option v-for="(app,key) in applications" :selected="selectedApplicationRef == app.id" :key="key" :value="app.id">{{app.name}}</option>
                        </select>
                    </div>

                    <div class=" mcc-segmented-buttons mcc-segmented-buttons--sm ">
                        <fieldset class="mfc-fieldset">
                            <legend class="mfc-label">
                                Disabled
                            </legend>
                            <div class="mcc-segmented-buttons__list" ref="radioRef" name="disabled-radioGroup" id="disabled-radioGroup">
                                <input type="checkbox" name="deleted" value="deleted" id="deleted" @click="processTypeRef = $event.target.value" :checked="processTypeRef =='deleted'">
                                <label class="mcc-segmented-buttons__button" for="deleted">
                                    <span class="mcc-segmented-buttons__label">Yes</span>
                                </label>
                                <input type="checkbox" name="active" value="active" id="active" @click="processTypeRef = $event.target.value" :checked="processTypeRef =='active'">
                                <label class="mcc-segmented-buttons__button" for="active">
                                    <span class="mcc-segmented-buttons__label">No</span>
                                </label>
                                <input type="checkbox" name="All" value=" " id="All" @click="processTypeRef = $event.target.value" :checked="processTypeRef ==' '">
                                <label class="mcc-segmented-buttons__button" for="All">
                                    <span class="mcc-segmented-buttons__label">All</span>
                                </label>

                            </div>
                        </fieldset>
                    </div>

                </div>
            </form>
            </div>
        </Drawer>
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>

            </div>

                </div>
                <div class="mcc-row" v-show="fetchCall">
                    <div class="mcc-col">
                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="mcc-card">
                                <div class="mcc-card__body">
                                    <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                        <button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                            <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                            <span class="mcc-button__label">Filters {{filterCount > 0 ? ` (${filterCount})` : '(1)'}}</span>
                                        </button>
                                    </div>
                                    <!-- <div class="mu-d-flex">

                                        <div role="group" class="mcc-button-group mcc-button-group--spaced">
                                            <button class="mcc-button mcc-button--sm mcc-button--secondary mcc-button--icon-only" v-show="selectedProcesses.length>0" id="copyProcessBtn" title="Copy processes" @click="copyProcess()">
                                                <mcc-icon name="copy" aria-hidden="true"></mcc-icon><span class="mcc-button__label"></span>
                                            </button>

                                        </div>

                                    </div> -->

                            <div>
                                <div>
                                    <div class="mcc-table-toolbar" v-show="selectedProcesses.length>0">
                                        <div class="mcc-table-batch-actions mcc-table-batch-actions--active">
                                            <div class="mcc-table-batch-actions__summary">
                                                <p class="mu-mb-00">{{selectedProcesses.length}} {{ selectedProcesses.length > 1 ? 'rows selected' : 'row selected'}}</p>
                                            </div>
                                            <div class="mcc-table-batch-actions__list">
                                                <div class="mcc-button-group mcc-button-group--spaced">
                                                    <button class="mcc-button mcc-button mu-border mu-border-ui-01" @click="copyProcess()" id="copyProcessBtn" title="Copy processes" v-show="selectedProcesses.length>0">
                                                        <mcc-icon name="copy" aria-hidden="true"></mcc-icon><span class="mcc-button__label"></span>
                                                        <label>Copy processes</label>
                                                    </button>
                                                    <button id="cancelBtn" class="mcc-button mcc-button--icon-only mcc-button--sm mcc-button--primary" @click="uncheckAll">
                                                        <mcc-icon name="cancel" aria-hidden="true"></mcc-icon>
                                                        <span class="mcc-button__label">Cancel</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <mcc-data-table ref="processTable" id="processTableId"></mcc-data-table>

                        </div>

                    </div>
                </div>

            </div>
        </div>

    </div>

</div>
</template>

<script>
import ApplicationFormAPI from "../../../services/ApplicationFormAPI";
import ApplicationProcessAPI from "../../../services/ApplicationProcessAPI";
import Drawer from '../../common/Drawer.vue';
import constantMessages from "../../../messages";
import {
    EventBus
} from "../../../services/event-bus";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

import Table from "@advanced/component-mosaic-table";
import Utils from "@/script_utils";

export default {
    name: "ApplicationProcessList",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["application.process.list"],
            nameRegex: constantMessages.PATTERNS["name"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            processes: [],
            searchCriteria: {},
            applications: {},
            selectedApplicationRef: "",
            selectedApplication: "",
            updateDialog: false,
            processName: "",
            processType: "active",
            processNameRef: "",
            processTypeRef: "active",
            selectedProcesses: [],
            tableObj: null,
            currentPageSize: 10,
            updateCall: true,
            appToCopyId: "",
            responseData: [],
            tableData: [],
            filterActive: false,
            filterData: [],
            filterCount: 0,
            pageStart: -1,
            fetchCall: false,
            selectInstanceEntities: "",
        };
    },
    created() {
        let self = this;
        this.selectInstanceEntities = new SlimSelect({
            select: '#application-selectId',

        })
    },
    mounted() {
        var self = this;
        Utils.applyFixedHeaderConfiguration(this);

        if (this.$route.params.otherProps != undefined) {
            this.appToCopyId = this.$route.params.otherProps.appToCopyId;
        }
        if (localStorage.getItem("ProcessList") === "ProcessList") {
            this.processTypeRef = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_processType"
            );
            this.processType = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_processType"
            );
            this.selectedApplication = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_selectedApplication"
            );
            this.selectedApplicationRef = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_selectedApplication"
            );
            this.processNameRef = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_processName"
            );
            this.processName = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_processName"
            );
            this.currentPageSize = parseInt(
                localStorage.getItem("ProcessListPageSize")
            );
            localStorage.removeItem("ProcessListPageSize");
            localStorage.removeItem("ProcessList");
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_processName"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_processType"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_selectedApplication"
            );
        }

        ApplicationFormAPI.getApplications()
            .then(result => {
                self.applications = result;
                self.fetchCall = true;
            })
            .finally(() => {
                self.initProcessTable();
                self.updateTemplate();

            });

        this.selectInstanceEntities = new SlimSelect({
            select: '#application-selectId',

        })
    },
    methods: {
        getFilterCount() {
            if (this.selectedApplicationRef != "")
                this.filterCount += 1;
            if (this.processNameRef != "")
                this.filterCount += 1;
            if (this.processTypeRef != "")
                this.filterCount += 1;
        },
        resetSlimSelect() {
            this.selectInstanceEntities.setSelected('')
        },
        resetForm() {
            this.filterCount = 0;
            this.updateCall = false;
            this.processTypeRef = "active";
            this.selectedApplicationRef = "";
            this.processNameRef = "";
            this.selectedApplication = "";
            this.processName = "";
            this.processType = "active";
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.initProcessTable();
            this.resetSlimSelect()
            this.updateTemplate();
        },
        submitDialog(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            this.filterCount = 0;
            this.getFilterCount();
            this.selectedApplication = this.selectedApplicationRef;
            this.processName = this.processNameRef;
            this.processType = this.processTypeRef;
            this.initProcessTable();
            this.updateTemplate();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        closeDialog() {
            this.updateDialog = false;
        },
        showDialog() {
            this.updateDialog = true;
        },
        updateTemplate() {
            var self = this;
            this.$refs.processTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        var targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            var reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/design/applications/" + reference.trim()
                            );
                        }
                    });
                });

            this.$refs.processTable
                .querySelectorAll('td [class="table-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        var targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            var reference = $(targetEle).attr("data-id");
                            var appId = $(targetEle).attr("data-app-id");
                            self.$router.push({
                                path: self.CONTEXT_PATH +
                                    "/design/applications/" +
                                    appId.trim() +
                                    "/appprocesses/" +
                                    reference.trim(),
                                query: {
                                    path: "process"
                                }
                            });
                        }
                    });
                });
        },
        uncheckAll() {
            let self = this;
            const selectedList = document.querySelectorAll("#processTableId input[type=checkbox]:checked");

            selectedList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            self.selectedProcesses = [];
        },
        copyProcess() {
            this.setFilterDataInLocalStorage();
            this.$router.push({
                path: this.CONTEXT_PATH +
                    "/design/applications/appprocesses/copy",
                name: "MultipleProcessCopy",
                params: {
                    otherProps: {
                        processIds: this.selectedProcesses,
                        appToCopyId: this.appToCopyId
                    }
                }
            });
        },
        initProcessTable() {
            var self = this;
            self.selectedProcesses = [];
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            this.tableObj = window.tableFactory.create(document.getElementById("processTableId"), {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No application processes found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,

                schema: {
                    properties: {
                        select: {
                            type: "boolean",
                            format: "checkbox",
                            title: "Select",
                            editable: true
                        },
                        applicationId: {
                            type: "string",
                            title: "Id",
                            hidden: true
                        },
                        name: {
                            type: "string",
                            title: "Name",
                            template: '<a class="table-link" data-id="{{id}}" data-app-id={{applicationId}}>{{name}}</a>',
                            sortable: true
                        },
                        processDisabled: {
                            type: "string",
                            title: "Disabled",
                            sortable: false
                        },
                        version: {
                            type: "string",
                            title: "Version",
                            sortable: false
                        },
                        applicationName: {
                            type: "string",
                            title: "Application name",
                            sortable: false,
                            template: '<a class="name-link" data-id="{{applicationId}}">{{applicationName}}</a>'
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        self.pageStart = start;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        var queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&processName=" +
                            self.processName +
                            "&currentAppId=" +
                            self.selectedApplication +
                            "&processType=" +
                            self.processType.trim();
                        return ApplicationProcessAPI.getProcesses(queryString).then(
                            result => {
                                var responseData = {
                                    totalCount: 0,
                                    data: []
                                };
                                responseData.totalCount = result.page.totalElements;
                                if (result.data != null) {
                                    result.data.forEach(resultField => {
                                        resultField.select =
                                            self.selectedProcesses.indexOf(resultField.id) != -1;
                                        resultField["disabledCheckbox"] = resultField.processDisabled == "Yes" || resultField.appInfo.deleted != null;
                                    });
                                    responseData.data = result.data;
                                }
                                self.responseData = responseData.data;
                                self.tableData = responseData.data;
                                return responseData;
                            }
                        );
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;

                    }
                },
                onAction: (table, action, rowObj) => {
                    if (action == "select") {
                        rowObj.forEach((obj, a) => {
                            if (obj.value && self.selectedProcesses.indexOf(obj.rowData.id) == -1) {
                                if (obj.rowData.processDisabled == "Yes" || obj.rowData.appInfo.deleted) {
                                    EventBus.$emit("warning-notification", {
                                        msg: obj.rowData.name + " cannot be copied as process/application is disabled."
                                    });
                                } else {
                                    self.selectedProcesses.push(obj.rowData.id);
                                }
                            } else if (!obj.value && obj.rowData.processDisabled == "No" && obj.rowData.appInfo.deleted == null) {
                                self.selectedProcesses.splice(self.selectedProcesses.indexOf(obj.rowData.id), 1);
                            }
                        });
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.responseData.forEach((item, index) => {
                        if (item.disabledCheckbox) {
                            self.tableObj.disableRowActions(self.pageStart + index);
                        }
                    });
                    self.updateTemplate();
                    self.updateCall = true;
                }
            });
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem("ProcessListPageSize", this.tableObj.tableContext.store.state.pageSize);
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_processType",
                this.processType
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_selectedApplication",
                this.selectedApplication
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_processName",
                this.processName
            );
        }
    }
};
</script>
